// extracted by mini-css-extract-plugin
export default {"misc_wrapper":"notAuthorized_misc_wrapper__5DPRA"};